import React from "react";

export default class FormAttributeDraggableCreator extends React.Component{

  faDataAsString = () => {
    return JSON.stringify(this.getFaData());
  }

  getFaData = () =>{
    return {
      draggable_type: this.props.draggable_type,
      display_type: this.props.display_type
    };
  }
  
  onClickAdd = () => {
    if (this.props.disableAdd !== true){
      this.props.onClickAdd(this.props.display_type)
    } else {
      console.error('this button should be disabled');
    }
  }
  
  render(){
    return (<div
      id={this.props.display_type}
      key={this.props.index}
      className="fa-display-type fa-draggable-type clearfix form-attribute-editor draggable"
      data-fa-object={this.faDataAsString()}
      data-id={`__${this.props.index}__`}
      onDragStart={this.props.onDragStartEvent}
      onDragEnd={this.props.onDragEndEvent}
      draggable="true">
      <button 
        className="float-right btn btn-primary btn-sm" 
        onClick={() => {this.onClickAdd(this.props.display_type)}}>
        <i className="fas fa-plus"></i>
      </button>
      {this.props.display_type.replace("_"," ")}
    </div>);
  }
}  